import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, unref } from "vue";
import BusinessProfileService from "@/services/organization/business-profile";
import { BusinessProfile } from "@/dtos/BusinessProfile.dto";

export interface BusinessProfileParams {
  organizationId: string;
}

export function useBusinessProfile(
  params: Ref<BusinessProfileParams | null> | BusinessProfileParams | null
) {
  const queryKey = computed(() => {
    const p = unref(params);
    if (!p) return ["businessProfile", "disabled"];
    return ["businessProfile", p.organizationId];
  });

  const enabled = computed(() => !!unref(params)?.organizationId);

  return useQuery({
    queryKey,
    queryFn: async (): Promise<BusinessProfile | null> => {
      const result = await BusinessProfileService.getBusinessProfile();

      let data = null;
      if (result.data?.status && result.data?.data) {
        data = result.data.data;
      } else if (result.data && !result.data.status) {
        data = result.data;
      }

      return data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
